export const RouterName = {
  auth: {
    login: "/auth/login",
    signup: "",
    forgotPassword: "/auth/forgot-password",
    resetPassword: "/auth/reset-password/:token",
    maintenance: "/auth/maintenance",
  },
  settings: {
    settings: "/settings",
    createSettings: "/settings/create",
  },
  equipments: {
    equipments: "/equipments",
    createEquipments: "/equipments/create",
  },
  legs: {
    legs: "/legs",
  },
  quickQuote: {
    quickQuote: "/quick-quote",
  },
  orders: {
    orders: "/orders",
    ordersDetail: "/order/:uuid",
    createOrder: "/order/new/:uuid",
  },
  OSND: {
    orders: "/osnd/orders",
    manifests: "/osnd/manifests",
    dashboard: "/osnd",
    createOrder: "/osnd/order/new/:uuid",
    orderDetail: "/osnd/order/:uuid",
    manifestDetail: "/osnd/manifest/blank/:id",
  },
  manifests: {
    manifests: "/manifests",
    blankManifest: "/manifest/blank",
  },
  control: {
    control: "/control",
  },
  customers: {
    customers: "/customers",
  },
  tariffs: {
    tariffs: "/tariffs",
    tariffDetails: "/tariff/:uuid",
  },
  carriers: {
    carriers: "/carriers",
  },
  dashboard: {
    dashboard: "/dashboard",
  },
  invoices: {
    invoices: "/invoices",
    consolidatedInvoice: "/consolidated-invoice/:uuid",
    document: "/documents/accounting/receivables/invoices/:uuid",
  },
  teams: {
    teams: "/teams",
  },
  accessorials: {
    accessorials: "/accessorials",
  },
  categories: {
    categories: "/categories",
  },
  zones: {
    zones: "/zones",
  },
  table: {
    table: "/table",
  },
};
